<!-- Main Container Wrapper -->
<div class="p-3 rounded-4 border shadow-sm bg-body-tertiary">

  <!-- Action Header Toolbar -->
  <div class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
    <div>
      <h5 class="fw-bold mb-1 text-body tracking-wide d-inline-flex align-items-center gap-2">
        <i class="bi bi-person-exclamation text-warning"></i>UnVerified Customer List
      </h5>
      <p class="text-body-secondary small mb-0">Review pending verification profiles and specific audit rejection notes
      </p>
    </div>

    <a class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1.5 shadow-sm text-body"
      routerLink="/nav/customer-list">
      <i class="bi bi-arrow-left"></i>
      <span>Back to Main List</span>
    </a>
  </div>

  <!-- Central Dashboard Panel Card Container -->
  <div class="card shadow-sm border-0 bg-body">
    <div class="card-body p-0">
      <!-- 🚀 UPGRADED WRAPPER: Implemented our optimized high-density scrolling layout class -->
      <div class="table-responsive-container m-0">
        <table class="table table-hover align-middle mb-0 table-dense text-nowrap">

          <!-- Table Header Matrix Structures with clear minimum widths allocated instead of tight % properties -->
          <thead
            class="table-light text-body-secondary font-monospace small text-uppercase border-bottom tracking-wider">
            <tr>
              <th scope="col" class="ps-3" width="60">No</th>
              <th scope="col" style="min-width: 130px;">Phone</th>
              <th scope="col" class="text-center" width="110">Profile Name</th>
              <th scope="col" class="text-center" width="100">NRC Front</th>
              <th scope="col" class="text-center" width="100">NRC Back</th>
              <th scope="col" class="text-center" width="110">NRC Number</th>
              <th scope="col" style="min-width: 140px;">Unverified By</th>
              <th scope="col" style="min-width: 240px;">Unverified Note</th>
              <th scope="col" class="pe-3 text-end" width="80">Action</th>
            </tr>
          </thead>

          <tbody class="font-xs text-body">
            @for (user of unverifiedList() | paginate : { itemsPerPage: pageSize(), currentPage: page(), totalItems:
            allTotal() }; track user.srNo) {
            <tr class="transition-base">
              <!-- Row ID Counter -->
              <td class="ps-3 text-body-secondary font-monospace fw-medium">{{ user.srNo }}</td>
              <td class="fw-semibold text-body font-monospace">{{ user.loginPhone }}</td>

              <!-- Profile Name Check State -->
              <td class="text-center">
                <span class="badge rounded-pill px-2 py-1 font-xs"
                  [ngClass]="user.profileName === false ? 'bg-danger-subtle text-danger-emphasis border border-danger-subtle' : 'bg-success-subtle text-success-emphasis border border-success-subtle'">
                  <i [ngClass]="user.profileName === false ? 'bi bi-x-lg' : 'bi bi-check-lg'"></i>
                </span>
              </td>

              <!-- NRC Front Document Check State -->
              <td class="text-center">
                <span class="badge rounded-pill px-2 py-1 font-xs"
                  [ngClass]="user.nrcFrontPhoto === false ? 'bg-danger-subtle text-danger-emphasis border border-danger-subtle' : 'bg-success-subtle text-success-emphasis border border-success-subtle'">
                  <i [ngClass]="user.nrcFrontPhoto === false ? 'bi bi-x-lg' : 'bi bi-check-lg'"></i>
                </span>
              </td>

              <!-- NRC Back Document Check State -->
              <td class="text-center">
                <span class="badge rounded-pill px-2 py-1 font-xs"
                  [ngClass]="user.nrcBackPhoto === false ? 'bg-danger-subtle text-danger-emphasis border border-danger-subtle' : 'bg-success-subtle text-success-emphasis border border-success-subtle'">
                  <i [ngClass]="user.nrcBackPhoto === false ? 'bi bi-x-lg' : 'bi bi-check-lg'"></i>
                </span>
              </td>

              <!-- NRC ID Formulation Check State -->
              <td class="text-center">
                <span class="badge rounded-pill px-2 py-1 font-xs"
                  [ngClass]="user.nrcNumber === false ? 'bg-danger-subtle text-danger-emphasis border border-danger-subtle' : 'bg-success-subtle text-success-emphasis border border-success-subtle'">
                  <i [ngClass]="user.nrcNumber === false ? 'bi bi-x-lg' : 'bi bi-check-lg'"></i>
                </span>
              </td>

              <!-- Moderator Meta Fields (Clean Truncation Rules to prevent text-bleeding) -->
              <td class="text-body-secondary text-truncate" style="max-width: 140px;"
                [title]="user.unverifiedBy || '—'">
                {{ user.unverifiedBy || '—' }}
              </td>
              <td>
                <span class="text-body-secondary d-inline-block text-truncate" style="max-width: 240px;"
                  [title]="user.unverifiedNote">
                  {{ user.unverifiedNote || 'No administrative rejection notes provided' }}
                </span>
              </td>

              <!-- Compact Centered Action Button Link -->
              <td class="pe-3 text-end">
                <a [routerLink]="['/nav/customer-info', user.loginPhone]"
                  class="btn btn-sm btn-icon btn-outline-secondary rounded-circle shadow-sm transition-base d-inline-flex align-items-center justify-content-center"
                  style="width: 28px; height: 26px;" title="View Profile Info">
                  <i class="bi bi-person-lines-fill text-body"></i>
                </a>
              </td>
            </tr>
            } @empty {
            <tr>
              <td colspan="9" class="text-center py-5 text-body-secondary">
                <div class="d-flex flex-column align-items-center justify-content-center w-100 text-center">
                  <i class="fa-regular fa-folder-open display-6 mb-3 opacity-50"></i>
                  <span class="tracking-wider"> Excellent! No unverified customer applications remaining in processing
                    queue.</span>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pagination Footer Navigation Control Container -->
    <div class="card-footer bg-transparent border-top py-2.5">
      <div class="d-flex justify-content-center">
        <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
          class="dashboard-pagination" (pageChange)="handlePageChange($event)">
        </pagination-controls>
      </div>
    </div>

  </div>
</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div
  class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
  style="backdrop-filter: blur(4px);">
  <!-- Mini Spinner -->
  <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <!-- Text Badge Layout (Uses your global micro utilities) -->
  <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">
    Loading...
  </div>
</div>
}